import { mainAxios } from "@/mainAxios.js";
import { getAgenteAccessToken } from "./tokens.service";

export const validarPagoEmision = async ({ polizaId }) => {
  const requestBody = { emision_id: polizaId };
  const config = {
    headers: {
      Authorization: "Bearer " + getAgenteAccessToken(),
    },
  };

    const serverResponse = await mainAxios.post(
      "/v1/inter/emision/validaPago",
      requestBody,
      config
    );
    
    return serverResponse

};

export const getEmisionByTitular = async (filters) => {
      const config = {
        headers: {
          Authorization: "Bearer " + getAgenteAccessToken(),
        },
        params: {
          filters: filters 
        },
      };
    const serverResponse = await mainAxios.get(
      "/v1/emision/validacion/titular",
      config
    );
    
    return serverResponse.data

};